import { memo, useCallback } from 'react';
import { useBotContext } from '../useBotContext';
import Button from '../atom/Button';
import Tooltip from '../atom/Tooltip';
import { BOT_FORM_STORAGE_KEY, createBotInitialData } from '../../helpers/data/bot';

const BotResetButton = memo(() => {
  const { setValue } = useBotContext();

  const handleReset = useCallback(() => {
    // Clear localStorage
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(BOT_FORM_STORAGE_KEY);
    }
    // Reset form to default values
    setValue(createBotInitialData());
  }, [setValue]);

  return (
    <Button
      className="bot-reset-button bg-transparent"
      name="reset"
      hasShadow={false}
      onClick={handleReset}
      primary
    >
      <Tooltip placement="right" title="Reset all values to defaults">
        <span className="icon-refresh-1 d-flex align-items-center gap-1" aria-hidden>
          reset
        </span>
      </Tooltip>
    </Button>
  );
});

BotResetButton.displayName = 'BotResetButton';

export default BotResetButton;
